import { createContext } from 'react';
const UserUpdateContext = createContext({});
export const UserUpdateProvider = UserUpdateContext.Provider;
export default UserUpdateContext;
